module.exports = __webpack_public_path__ + "img/duanwujie_5.06f8e6cb.png";